import { Skeleton } from '@/components/ui/skeleton';
import { cn } from '@/lib/utils/cn';

interface TableSkeletonProps {
  rows?: number;
  columns?: number;
  className?: string;
}

export function TableSkeleton({ rows = 6, columns = 5, className }: TableSkeletonProps) {
  return (
    <div
      role="status"
      aria-label="Cargando tabla"
      className={cn('overflow-hidden rounded-xl border border-border bg-surface', className)}
    >
      <div className="flex gap-4 border-b border-border bg-surface-muted px-3 py-3">
        {Array.from({ length: columns }, (_, index) => (
          <Skeleton key={index} className="h-3 flex-1" />
        ))}
      </div>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <div key={rowIndex} className="flex gap-4 border-b border-border px-3 py-3.5 last:border-0">
          {Array.from({ length: columns }, (_, columnIndex) => (
            <Skeleton
              key={columnIndex}
              className={cn('h-3.5 flex-1', columnIndex === 0 && 'flex-[1.6]')}
            />
          ))}
        </div>
      ))}
    </div>
  );
}

/** Generic page placeholder used while route chunks load. */
export function PageSkeleton() {
  return (
    <div role="status" aria-label="Cargando página" className="space-y-6">
      <div className="space-y-2 border-b border-border pb-5">
        <Skeleton className="h-3 w-24" />
        <Skeleton className="h-6 w-64" />
        <Skeleton className="h-4 w-96 max-w-full" />
      </div>
      <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {Array.from({ length: 4 }, (_, index) => (
          <Skeleton key={index} className="h-24" />
        ))}
      </div>
      <TableSkeleton />
    </div>
  );
}
